import { PlannerCredentials } from '../../domain/credentials/PlannerCredentials';
import { User } from '../../domain/user/User';

export enum UserActionType {
  FETCH_ADMIN_USER_SUCCESS = `FETCH_ADMIN_USER_SUCCESS`,
  FETCH_USER_SUCCESS = `FETCH_USER_SUCCESS`,
  UPDATE_USER_SUCCESS = `UPDATE_USER_SUCCESS`,
  FETCH_USER_CREDENTIALS_SUCCESS = `FETCH_USER_CREDENTIALS_SUCCESS`,
  RESET_USER = `RESET_USER`,
}

export interface FetchAdminUserSuccessAction {
  type: UserActionType.FETCH_ADMIN_USER_SUCCESS;
  payload: {
    adminUser: User;
  };
}

export interface FetchUserSuccessAction {
  type: UserActionType.FETCH_USER_SUCCESS;
  payload: {
    user: User;
  };
}

export interface UpdateUserSuccessAction {
  type: UserActionType.UPDATE_USER_SUCCESS;
  payload: {
    user: User;
  };
}

export interface FetchUserCredentialsSuccessAction {
  type: UserActionType.FETCH_USER_CREDENTIALS_SUCCESS;
  payload: {
    credentials: PlannerCredentials;
  };
}

export interface ResetUserAction {
  type: UserActionType.RESET_USER;
}

export type UserActions =
  | FetchAdminUserSuccessAction
  | FetchUserSuccessAction
  | UpdateUserSuccessAction
  | FetchUserCredentialsSuccessAction
  | ResetUserAction;
